import React from 'react';
import { Combo } from 'fw/forms';
import * as API from 'modules/app/API'

class CountryCombo extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
        this._isMounted = false;
    }

    completed = () => { return this._ctrl.completed(); }
    flag = () => { return this._ctrl.flag(); }

    componentDidMount() {
		this._isMounted = true;

		API.App.get('/query/getCountries', {},
			{
				success: (r) => {
					this._isMounted && this.setState({
						items: r.data.items.map((item) => { return { label: item.countryName, value: item.countryCode } })
					});
				}
			},
			{ block: false });
	}

    componentWillUnmount() {
		this._isMounted = false;
	}

    render() {
        return (
            <Combo
                {...this.props}
                placeholder="Country..."
                items={this.state.items}
                searchable={true}
                ref={(c) => { this._ctrl = c}} />
        )
    }
}

export default CountryCombo;

// Mark this as a form component
CountryCombo.defaultProps = {
    formControl: true,
    managed: false
};



// WEBPACK FOOTER //
// ./src/areas/shared/controls/countryCombo/CountryCombo.js